// CPF validator with check-digit verification (Brazilian document).

export default function validateCpf(input) {
  if (!input) return false;
  const digits = String(input).replace(/\D/g, '');

  if (digits.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(digits)) return false;

  const calcCheck = (slice) => {
    const factor = slice.length + 1;
    const sum = slice
      .split('')
      .reduce((acc, n, i) => acc + Number(n) * (factor - i), 0);
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };

  const firstCheck = calcCheck(digits.substring(0, 9));
  if (firstCheck !== Number(digits.charAt(9))) return false;

  const secondCheck = calcCheck(digits.substring(0, 10));
  if (secondCheck !== Number(digits.charAt(10))) return false;

  return true;
}
